export default __webpack_public_path__ + "static/media/Logo_GreenScan-05.f3b4fc90.svg";